import { EnsureRepositoryQueryData } from '@mews-commander/data-access';
import { getFullName } from '@mews-commander/utils';

interface SetCustomerNameAsDocumentTitleParams {
    ensureQueryData: EnsureRepositoryQueryData;
    id: string;
}

export const getCustomerNameToDocumentTitle = async ({ ensureQueryData, id }: SetCustomerNameAsDocumentTitleParams) =>
    await ensureQueryData('accounts', 'getAll', { accountIds: [id] }).then(({ customers }) => ({
        documentTitle: () => getFullName(customers?.[0]).trim(),
    }));
